import React from 'react';
import Header from './Header';
import MobileDrawer from './MobileDrawer';
import Hero from './Hero';
import Accommodations from './Accommodations';
import Wonders from './Wonders';
import Sustainability from './Sustainability';
import Contact from './Contact';
import Footer from './Footer';
import Lightbox from './Lightbox';
import BookingModal from './BookingModal';
import Toast from './Toast';

const MainSite = ({ 
  stays,
  wonders,
  isLoading,
  scrolled, 
  headerVisible, 
  setIsMenuOpen, 
  scrollTo, 
  isMenuOpen, 
  openLightbox, 
  openBooking, 
  showToast, 
  lightboxIndex, 
  activeGallery, 
  closeLightbox, 
  nextImage, 
  prevImage, 
  isBookingOpen, 
  closeBooking, 
  selectedStay, 
  toast, 
  closeToast 
}) => {
  return (
    <div className="nature-texture min-h-screen">
      <Header scrolled={scrolled} headerVisible={headerVisible} setIsMenuOpen={setIsMenuOpen} scrollTo={scrollTo} />
      
      <MobileDrawer isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} scrollTo={scrollTo} />
      
      <main>
        <Hero scrollTo={scrollTo} />
        <Accommodations stays={stays} isLoading={isLoading} openLightbox={openLightbox} openBooking={openBooking} scrollTo={scrollTo} />
        <Wonders wonders={wonders} isLoading={isLoading} openLightbox={openLightbox} />
        <Sustainability />
        <Contact showToast={showToast} />
      </main>

      <Footer scrollTo={scrollTo} />

      <Lightbox 
        image={lightboxIndex !== null ? activeGallery[lightboxIndex] : null} 
        index={lightboxIndex}
        total={activeGallery?.length || 0}
        onClose={closeLightbox} 
        onNext={nextImage} 
        onPrev={prevImage} 
      />

      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={closeBooking} 
        selectedStay={selectedStay} 
        showToast={showToast}
      />

      <Toast 
        message={toast.message} 
        isVisible={toast.isVisible} 
        onClose={closeToast} 
      />
    </div>
  );
};

export default MainSite;
